// Client de los reembolsos de enganche del portal del vendedor; la tienda la acota el token.
import type { SellerPendingRefundItem } from '@fiado/type-kit/bin/retailWizard/dtos/SellerPendingRefundItem';
import type { StorePendingRefundsResponse } from '@fiado/type-kit/bin/retailWizard/dtos/responses/StorePendingRefundsResponse';
import { apiFetch } from '../../client';
import { UnexpectedShapeError } from '../../errors';

const BASE_URL = import.meta.env.VITE_API_RETAIL_WIZARD_BASE_URL;
const PATH = '/portal/pending-refunds';

export interface PortalRefundsApi {
    list: () => Promise<StorePendingRefundsResponse>;
    deliver: (sessionId: string) => Promise<SellerPendingRefundItem>;
}

/** Una respuesta sin lista o sin totales no es «cero pendientes»: es una respuesta que no se entiende. */
function assertRefundsResponse(
    wire: Partial<StorePendingRefundsResponse> | null,
): asserts wire is StorePendingRefundsResponse {
    if (
        !wire ||
        !Array.isArray(wire.refunds) ||
        typeof wire.pendingCount !== 'number' ||
        typeof wire.pendingTotalCents !== 'number'
    ) {
        throw new UnexpectedShapeError(
            `GET ${PATH}`,
            'faltan refunds, pendingCount o pendingTotalCents',
        );
    }
}

export const portalRefundsClient: PortalRefundsApi = {
    list: async () => {
        const wire = await apiFetch<Partial<StorePendingRefundsResponse> | null>(PATH, {
            baseUrl: BASE_URL,
        });
        assertRefundsResponse(wire);
        return {
            refunds: wire.refunds,
            pendingCount: wire.pendingCount,
            pendingTotalCents: wire.pendingTotalCents,
        };
    },
    deliver: (sessionId) =>
        apiFetch<SellerPendingRefundItem>(`${PATH}/${encodeURIComponent(sessionId)}/deliver`, {
            method: 'POST',
            baseUrl: BASE_URL,
        }),
};
